"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _msalReact = require("@azure/msal-react");
var defaultAuth = _interopRequireWildcard(require("./_auth"));
var _LoginModule = _interopRequireDefault(require("./Login.module.css"));
var _Types = require("../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DefaultLogin = _ref => {
  let {
    authFile = null
  } = _ref;
  const {
    instance
  } = (0, _msalReact.useMsal)();
  (0, _react.useEffect)(() => {
    instance.handleRedirectPromise().then(tokenResponse => {
      if (!tokenResponse) {
        const accounts = instance.getAllAccounts();
        if (accounts.length === 0) {
          instance.loginRedirect(authFile ? authFile.loginRequest : defaultAuth.loginRequest).then(() => {});
        }
      }
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error(err);
    });
  }, [authFile, instance]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _LoginModule.default.login_wrap
  });
};
exports.DefaultLogin = DefaultLogin;
DefaultLogin.propTypes = {
  authFile: _Types.AuthFileType
};
DefaultLogin.defaultProps = {
  authFile: null
};